import { defineStore } from 'pinia'
import { type SubModule } from '@/types/modules'
import { ref } from 'vue'
import { axiosClient } from '@/utils/axios-client'

export const useModuleStore = defineStore('modules', () => {
  const subModules = ref<SubModule[]>([])

  async function fetchModules() {
    const response = await axiosClient.request<SubModule[]>({ url: '/auth/api/submodules' })

    subModules.value = response.data
    return response.data
  }

  return {
    subModules,
    fetchModules,
  }
})
